import { Button } from '@/components/Button';

export type AuthButtonProps = {
  text: string;
  disabled?: boolean;
  onClick?: () => void;
};

export const AuthButton = ({ text, disabled, onClick }: AuthButtonProps) => {
  return (
    <Button
      text={text}
      buttonClassName="w-full h-[44px] rounded-full"
      textClassName="text-md"
      disabled={disabled}
      onClick={onClick}
    />
  );
};
